import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

class TallaCamiseta extends React.Component {

    constructor(props) {
        super(props);
        this.value = '';
    }

    onTrigger = (event) => {
        this.props.parentCallback(event);
    };

 
    render() {
        return (
        
            <FormControl fullWidth size="small" required>
                <InputLabel id="select-label">{this.props.label}</InputLabel>
                <Select
                    id={this.props.name}
                    label={this.props.label}
                    labelId="select-label"
                    name={this.props.name}
                    onChange={this.onTrigger}
                    defaultValue={this.value}
                >
                    <MenuItem value="XS (estandar)">XS (estándar)</MenuItem>
                    <MenuItem value="S (estandar)">S (estándar)</MenuItem>
                    <MenuItem value="M (estandar)">M (estándar)</MenuItem>
                    <MenuItem value="L (estandar)">L (estándar)</MenuItem>
                    <MenuItem value="XL (estandar)">XL (estándar)</MenuItem>
                    <MenuItem value="S (niño)">S (niño)</MenuItem>
                    <MenuItem value="M (niño)">M (niño)</MenuItem>
                    <MenuItem value="L (niño)">L (niño)</MenuItem>
                    <MenuItem value="XL (niño)">XL (niño)</MenuItem>
                </Select>
            </FormControl>
        );
    }
}
export default TallaCamiseta;

